import { I18n } from 'aws-amplify/utils';
import { signal } from '@angular/core';
import { translations } from '@aws-amplify/ui-angular';
import { AvailableLangs, TranslocoService } from '@jsverse/transloco';
import { inject, Injectable } from '@angular/core';

const DEFAULT_LANG = 'en';
const LANG_STORAGE_KEY="currentLang"
@Injectable({
  providedIn: 'root'
})
export class LanguagesService {
    private translocoService = inject(TranslocoService);
    
    private availableLanguages: Language[]=[];
    private currentLang:string=DEFAULT_LANG;
    
    currentLang$ = signal(this.currentLang);
    availableLangs$ = signal(this.availableLanguages);

    constructor(){
        I18n.putVocabularies(translations);
        const langs = this.translocoService.getAvailableLangs();
        this.availableLanguages = langs.map((lang) => {
            return {
                code: lang.id,
                name: lang.label,
            };
        }
        );
        this.availableLangs$.set(this.availableLanguages);
    }

    public init(){
        var appLang = this.getStoredLang();
        if(!appLang){
            appLang= this.getBroserLang();
        }
        this.setLang(appLang, false);
    }

    public setLang(lang:string, save:boolean=false) {
        if(this.availableLanguages.findIndex((l) => l.code === lang) === -1){
            console.log(`Language [${lang} not found in available languages. Using default`);
            this.translocoService.setActiveLang(DEFAULT_LANG);
            I18n.setLanguage(DEFAULT_LANG);
        }else{
            console.log('Language found in available languages:', lang);
            this.translocoService.setActiveLang(lang);
            
            //Set the amplify authenticator component language
            I18n.setLanguage(lang);
            if(save){
                localStorage.setItem(LANG_STORAGE_KEY, lang);
            }
            this.currentLang=lang;
            this.currentLang$.set(lang);
        }
    }

    private getStoredLang(){
        return localStorage.getItem(LANG_STORAGE_KEY);
    }


    private getBroserLang(){
        const browserLang = navigator.language.split('-')[0];
        console.log('Browser language:', browserLang);
        return browserLang;
    }
}

export interface Language {code:string,name:string};

//Amplify Authenticator translations
//https://ui.docs.amplify.aws/angular/connected-components/authenticator/customization#internationalization-i18n
// en – English (default)
// zh – Chinese
// nl – Dutch
// fr – French
// de – German
// he – Hebrew
// id – Indonesian
// it – Italian
// ja – Japanese
// ko – Korean
// nb - Norwegian
// pl – Polish
// pt – Portuguese
// ru – Russian
// es – Spanish
// sv – Swedish
// th - Thai
// tr – Turkish
// ua – Ukrainian
